import { Link } from "react-router-dom";

const TEAM_IMG = "https://images.unsplash.com/photo-1573164574511-73c773193279?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwYnVzaW5lc3MlMjB0ZWFtJTIwbWVldGluZyUyMGVudHJlcHJlbmV1cnMlMjBtdWx0aWN1bHR1cmFsfGVufDB8fHx8MTc3NjU4NTU4OXww&ixlib=rb-4.1.0&q=85";

const HERO_VIDEO = "https://videos.pexels.com/video-files/3255275/3255275-uhd_2560_1440_25fps.mp4";
const HERO_POSTER = "https://images.pexels.com/photos/5257005/pexels-photo-5257005.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const challenges = [
  { icon: "fa-hat-wizard", title: "Wearing Too Many Hats", desc: "You're the CEO, marketer, accountant, and janitor. You can't grow when you're doing everything yourself." },
  { icon: "fa-shield-halved", title: "Unprotected & Exposed", desc: "One lawsuit, one disaster, one key person loss — and everything you've built could disappear overnight." },
  { icon: "fa-chart-line", title: "Data Without Direction", desc: "You have data but no dashboard. Numbers without insight lead to guesswork, not growth." },
  { icon: "fa-folder-open", title: "Disorganized Operations", desc: "No SOPs, no systems, no documentation. You can't scale what lives only in your head." },
  { icon: "fa-money-bill-wave", title: "Financial Fog", desc: "Cashflow confusion, pricing uncertainty, and no financial roadmap for the future." },
  { icon: "fa-heart-pulse", title: "Neglected Wellness", desc: "Entrepreneur burnout is real. You can't pour from an empty cup — your wellness matters." },
];

const whyCards = [
  { icon: "fa-globe-americas", title: "Nationwide & International", desc: "Serving entrepreneurs and enterprises across the United States and internationally." },
  { icon: "fa-cubes", title: "All-In-One Resource", desc: "Stop juggling multiple vendors. One relationship, one resource center, unlimited support." },
  { icon: "fa-user-tie", title: "Founder-Led Expertise", desc: "Every client works directly with our CEO — no account managers, no runaround." },
  { icon: "fa-handshake", title: "Relationship-First", desc: "Long-term partnerships, not transactions. We're invested in your success from day one." },
  { icon: "fa-chart-pie", title: "Data-Driven Decisions", desc: "We help you build dashboards and analytics that turn data into actionable business intelligence." },
  { icon: "fa-shield-alt", title: "Comprehensive Protection", desc: "From insurance to succession planning — we protect what you've built at every stage." },
];

const programs = [
  {
    icon: "A",
    title: "Business Logic",
    items: [
      "Business Formation & Legal Structure",
      "Business Plan Development",
      "Marketing & Brand Strategy",
      "Data Analytics & Business Intelligence",
      "Project Management",
      "Process Management & Improvement",
      "HR & Talent Advisory",
    ],
  },
  {
    icon: "B",
    title: "Insurance + Assurance = Financial Freedom",
    items: [
      "Life, Health & Disability Insurance",
      "Business Liability & Property Insurance",
      "Risk Assessment & Management",
      "Retirement & Wealth Planning",
      "Investing: Mutual Funds, Annuities & More",
      "Employee Benefits & Group Plans",
    ],
  },
  {
    icon: "C",
    title: "Paradigm Shift Architects",
    items: [
      "Business Transformation Strategy",
      "Executive & Leadership Coaching",
      "Wellness Warriors Entrepreneur Wellness",
      "Succession & Exit Planning",
      "Crisis Management & Recovery",
      "Mergers & Acquisitions Advisory",
    ],
  },
];

export const HomePage = () => {
  return (
    <main data-testid="home-page">
      {/* HERO */}
      <section className="pg-hero" data-testid="hero-section" style={{ position: "relative" }}>
        {/* Video Background */}
        <video
          autoPlay loop muted playsInline
          poster={HERO_POSTER}
          style={{
            position: "absolute", inset: 0, width: "100%", height: "100%",
            objectFit: "cover", zIndex: 0
          }}
        >
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        {/* Dark Overlay */}
        <div style={{
          position: "absolute", inset: 0, zIndex: 1,
          background: "linear-gradient(135deg, rgba(26,26,46,.82) 0%, rgba(13,17,23,.78) 100%)"
        }} />
        <div className="pg-container" style={{ position: "relative", zIndex: 2 }}>
          <div className="pg-hero-content">
            <div className="pg-hero-badge">
              <i className="fas fa-globe" /> THE TRUSTED RESOURCE CENTER FOR BUSINESS OWNERS
            </div>
            <h1>THE TRUSTED RESOURCE CENTER<br />FOR BUSINESS OWNERS</h1>
            <p className="pg-hero-tagline">"Being an Entrepreneur Shouldn't Mean BEING Alone"</p>
            <p className="pg-hero-desc">
              <strong>NATIONWIDE AND INTERNATIONAL</strong> partners who bring together business strategy,
              insurance, funding, analytics, and more — so you never have to navigate alone.
            </p>
            <div className="pg-hero-cta">
              <Link to="/consultation" className="pg-btn pg-btn-primary" data-testid="hero-cta-primary">
                <i className="fas fa-calendar-check" /> Book Consultation
              </Link>
              <Link to="/services" className="pg-btn pg-btn-outline-white" data-testid="hero-cta-secondary">
                <i className="fas fa-arrow-right" /> Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* NATIONWIDE BAR */}
      <div className="pg-nw-bar">
        <div className="pg-container" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "1rem", flexWrap: "wrap" }}>
          <span className="pg-nw-badge">
            <i className="fas fa-globe-americas" /> NATIONWIDE AND INTERNATIONAL
          </span>
          <span style={{ fontSize: ".85rem", color: "#555", fontWeight: 500 }}>
            Serving entrepreneurs, small businesses, and enterprises across the U.S. and abroad
          </span>
        </div>
      </div>

      {/* STATS STRIP */}
      <section className="pg-stats-strip" data-testid="stats-section">
        <div className="pg-container">
          <div className="pg-stats-grid">
            <div className="pg-stat-item">
              <h3>ONE</h3>
              <p>Strategic Partner for All Your Business Needs</p>
            </div>
            <div className="pg-stat-item">
              <h3>9+</h3>
              <p>Core Success Avenues & Service Areas</p>
            </div>
            <div className="pg-stat-item">
              <h3>&infin;</h3>
              <p>Resources, Connections & Ongoing Support</p>
            </div>
          </div>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="pg-section" data-testid="who-we-are">
        <div className="pg-container">
          <div className="pg-two-col">
            <div>
              <span className="pg-label">About Us</span>
              <h2>Paradigm Global Business Solutions</h2>
              <div className="pg-divider left" />
              <p>
                Paradigm Global Business Solutions is a full-service <strong>ADVISORY SERVICES</strong> firm dedicated to empowering
                entrepreneurs and corporations to achieve long-term financial and personal success. Through
                education, advocacy, and expert guidance, we deliver the tools and resources needed to build a
                stronger future.
              </p>
              <p>
                Founded in 2020, our firm combines deep expertise in business strategy,
                risk management, and financial literacy to provide full spectrum business services
                to help entrepreneurs at every stage — from startup to succession.
              </p>
              <p style={{ fontWeight: 700, color: "var(--magenta)" }}>
                NATIONWIDE AND INTERNATIONAL — your business has no borders, and neither do we.
              </p>
              <div style={{ marginTop: "1.5rem", display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                <Link to="/consultation" className="pg-btn pg-btn-primary">Schedule Strategy Session</Link>
                <Link to="/services" className="pg-btn pg-btn-secondary">Our Services</Link>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={TEAM_IMG}
                alt="Paradigm Team"
                style={{ borderRadius: 16, boxShadow: "var(--shadow)", maxHeight: 400, width: "100%", objectFit: "cover" }}
              />
              <div style={{ marginTop: "1.4rem", background: "var(--bg-pink)", borderLeft: "4px solid var(--magenta)", padding: "1rem 1.2rem", borderRadius: "0 8px 8px 0", textAlign: "left" }}>
                <p style={{ margin: 0, fontStyle: "italic", fontSize: ".93rem" }}>
                  "Paradigm isn't just a company — it's a movement to change how entrepreneurs access support."
                </p>
                <cite style={{ display: "block", marginTop: ".45rem", fontWeight: 700, fontSize: ".82rem", fontStyle: "normal", color: "var(--magenta)" }}>
                  — Ekeyah Wallace, CEO & Founder
                </cite>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CHALLENGES */}
      <section className="pg-section pg-section-light" data-testid="challenges-section">
        <div className="pg-container">
          <div className="pg-text-center">
            <span className="pg-label">The Problem</span>
            <h2>The Challenges Entrepreneurs Face</h2>
            <div className="pg-divider" />
            <p className="pg-intro">
              Running a business alone is overwhelming. Most entrepreneurs juggle too many responsibilities
              with too few resources. Sound familiar?
            </p>
          </div>
          <div className="pg-cards-grid">
            {challenges.map((c, i) => (
              <div className="pg-card" key={c.title} data-testid={`challenge-card-${i}`}>
                <div className="pg-card-ico"><i className={`fas ${c.icon}`} /></div>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* THREE PILLARS / PROGRAMS */}
      <section className="pg-section" data-testid="programs-section">
        <div className="pg-container">
          <div className="pg-text-center">
            <span className="pg-label">Our Programs</span>
            <h2>Three Pillars of Business Success</h2>
            <div className="pg-divider" />
          </div>
          <div className="pg-prog-grid">
            {programs.map((prog, i) => (
              <div className="pg-prog-card" key={prog.title} data-testid={`program-card-${i}`}>
                <div className="pg-prog-hd">
                  <div className="ico">{prog.icon}</div>
                  <h3>{prog.title}</h3>
                </div>
                <div className="pg-prog-bd">
                  <ul className="pg-prog-list">
                    {prog.items.map((item, j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                  <Link to="/consultation" className="pg-btn pg-btn-primary" style={{ marginTop: "auto", justifyContent: "center" }}>
                    Get Started
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* QUOTE BAND */}
      <section className="pg-quote-band" data-testid="quote-section">
        <div className="pg-container">
          <blockquote>
            "Success isn't just about strategy — it's about having the right people in your corner who genuinely care about your vision."
          </blockquote>
          <cite>— Ekeyah Wallace, CEO & Founder | Paradigm Global Business Solutions</cite>
        </div>
      </section>

      {/* WHY PARADIGM */}
      <section className="pg-section pg-section-light" data-testid="why-section">
        <div className="pg-container">
          <div className="pg-text-center">
            <span className="pg-label">Why Paradigm</span>
            <h2>Why Choose Paradigm Global Business Solutions</h2>
            <div className="pg-divider" />
          </div>
          <div className="pg-why-grid">
            {whyCards.map((w, i) => (
              <div className="pg-why-card" key={w.title} data-testid={`why-card-${i}`}>
                <span className="ico"><i className={`fas ${w.icon}`} /></span>
                <h4>{w.title}</h4>
                <p>{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TRUST SIGNALS */}
      <section className="pg-section">
        <div className="pg-container">
          <div className="pg-text-center">
            <span className="pg-label">Trusted by Entrepreneurs</span>
            <h2>What Our Clients Say</h2>
            <div className="pg-divider" />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "1.5rem" }}>
            {[
              { quote: "Paradigm helped me restructure my entire business model. The advisory services were exactly what I needed to scale.", name: "Business Owner", role: "Small Business, FL" },
              { quote: "From insurance to funding strategy — having one team handle everything saved me time, money, and stress.", name: "Entrepreneur", role: "Startup Founder" },
              { quote: "The financial literacy program changed how I approach business decisions. I finally understand my numbers.", name: "Corporate Client", role: "Enterprise Partner" },
            ].map((t) => (
              <div key={t.name} style={{ background: "#fff", border: "1px solid var(--border)", borderRadius: 16, padding: "1.5rem", position: "relative" }}>
                <i className="fas fa-quote-left" style={{ color: "var(--magenta)", opacity: .2, fontSize: "2rem", position: "absolute", top: 16, left: 20 }} />
                <p style={{ fontSize: ".92rem", color: "var(--text)", lineHeight: 1.7, marginBottom: "1rem", paddingTop: ".5rem" }}>{t.quote}</p>
                <div style={{ display: "flex", alignItems: "center", gap: ".6rem" }}>
                  <div style={{ width: 36, height: 36, borderRadius: "50%", background: "var(--grad)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: ".7rem", fontWeight: 700 }}>
                    <i className="fas fa-user" />
                  </div>
                  <div>
                    <p style={{ fontWeight: 600, color: "var(--black)", margin: 0, fontSize: ".85rem" }}>{t.name}</p>
                    <p style={{ color: "var(--muted)", margin: 0, fontSize: ".78rem" }}>{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="pg-cta-banner" data-testid="cta-section">
        <div className="pg-container">
          <h2>Ready to Start Your Financial Journey?</h2>
          <p>
            Speak with a Paradigm Global advisor and take the first step toward building,
            protecting, and growing your business.
          </p>
          <div className="pg-cta-btns">
            <Link to="/consultation" className="pg-btn pg-btn-white" data-testid="cta-book-button">
              <i className="fas fa-calendar-check" /> Speak With An Advisor
            </Link>
            <Link to="/services" className="pg-btn pg-btn-outline-white">
              <i className="fas fa-arrow-right" /> Learn More
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HomePage;
